import { Component } from '@angular/core';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { MatCard, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'app-user-registration-confirmation-page',
    imports: [
    FooterComponent,
    MatCard,
    MatCardContent,
],
    templateUrl: './user-registration-confirmation-page.component.html',
    styleUrl: './user-registration-confirmation-page.component.scss'
})
export class UserRegistrationConfirmationPageComponent {}
